import React, { Suspense, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import { ErrorBoundary } from '@sentry/react';
import { Switch, Route, Link, useLocation } from 'react-router-dom';
import cx from 'classnames';
import { Button, CircularProgress, Modal } from '@material-ui/core';
import DelayedFallback from './components/DelayedFallback';
import AisleSideBar from './aisle/Sidebar';
import GrowzSideBar from './growz/SideBar';
import StoresSideBar from './stores/SideBar';
import Router from '../Router';
import './style/main.scss';
import ErrorRenderPage from './ErrorRenderPage';
import PageLoader from './components/PageLoader';
import desktopView from '../assets/images/deskopView_banner.png';
import bannerImage from '../assets/images/onboardingLinkpromo.png';
import http from '../config/http';
import { ONBOARDING_SEND_EMAIL } from '../config/api';
import { _route, isImpersonating } from '../utils';
// import starsIcon from '../assets/icons/stars.svg';

const useStyles = makeStyles((theme) => ({
  mob_restrict_holder: {
    display: 'none',
    // [theme.breakpoints.down('sm')]: {
    // display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    opacity: 1,
    transition: 'opacity 400ms ease-in',
    overflowY: 'scroll',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '999999',
    // },
  },
  mob_restrictBox: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  mob_restrict_box: {
    maxWidth: '450px',
    width: '95%',
    margin: '46px auto',
    overflow: 'hidden',
    transition: '0.6s',
    bottom: 0,
    background: '#fff',
    padding: '0px',
    textAlign: 'center',
    borderRadius: '10px',
    position: 'relative',
    outline: 'none',
  },
}));

function MainLayout() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { menuCollapsed, loading } = useSelector(({ layout }) => layout);
  const { user, realm, store } = useSelector(({ auth }) => auth);
  const { storeId } = store;
  const [sendEmail, setSendEmail] = useState({ loading: false, text: 'Send me the Link', emailSent: false });
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const dialogOptions = {
    user: {
      email: user.email,
      name: user.name,
    },
  };

  const sendLink = async () => {
    setSendEmail({ ...sendEmail, loading: true, emailSent: false });
    try {
      await http.post(ONBOARDING_SEND_EMAIL).then(() => {
        setSendEmail({ loading: false, text: 'Resend Link', emailSent: true });
      });
    } catch (error) {
      setSendEmail({ loading: false, text: 'Resend Link', emailSent: false });
    }
  };

  const restrictedRoutes = [
    _route('onboarding'),
    _route('marketplace'),
    _route('onboarding.store', { storeId }),
    _route('stores'),
    _route('users'),
    _route('users.add'),
    _route('roles'),
    _route('roles.create'),
    _route('sellergpt', { realm }),
    _route('subscription.selectAddOns', { realm }),
    _route('subscription.addOns', { realm }),
  ];

  return (
    <>
      <Switch>
        <Route path={['/aisle']}>
          <AisleSideBar />
        </Route>
        <Route path={['/growz']}>
          <GrowzSideBar />
        </Route>
        <Route path={['/stores']}>
          <StoresSideBar />
        </Route>
      </Switch>

      <div className={cx('page-container', { expanded: menuCollapsed })} open>
        <div className="loading-holder">
          <ErrorBoundary fallback={ErrorRenderPage} showDialog dialogOptions={dialogOptions}>
            <Suspense fallback={<DelayedFallback />}>
              {loading && <PageLoader />}
              <Router />
              {isImpersonating() &&
                !restrictedRoutes.includes(pathname) &&
                pathname.indexOf('/edit') === -1 &&
                pathname.indexOf('/launch') === -1 && (
                  <Link
                    style={{
                      position: 'fixed',
                      zIndex: 99,
                      padding: '0 !important',
                      margin: '0 !important',
                      border: 'none',
                      bottom: '20px',
                      right: '84px',
                      maxWidth: '140px',
                      width: '140px',
                      maxHeight: '48px',
                      height: '48px',
                      borderRadius: '30px',
                      background: 'linear-gradient(171deg, #1e38ea, #324af0, #8489f7, #6764ff)',
                      cursor: 'pointer',
                      boxShadow: '0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16)',
                      transition: 'transform 167ms cubic-bezier(0.33, 0.00, 0.00, 1.00)',
                      boxSizing: 'content-box',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '16px',
                      color: '#fff',
                      fontWeight: 500,
                      backgroundSize: '400%',
                    }}
                    to={_route('sellergpt', { realm })}
                  >
                    {/* <img src={starsIcon} /> */}
                    <span style={{ display: 'flex' }}>SellerGPT</span>
                  </Link>
                )}
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>

      <div className={classes.mob_restrictBox}>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          {/* <div className={classes.mob_restrict_holder}> */}
          <div className={classes.mob_restrict_box}>
            <div>
              <img src={bannerImage} style={{ maxWidth: '100%' }} />
            </div>
            <div style={{ padding: '0px 20px', margin: '1rem 0' }}>
              <h4 style={{ lineHeight: 1.875, fontSize: '1.25rem', marginBottom: '0', marginTop: '0' }}>
                Complete the onboarding process
              </h4>
              <p
                style={{
                  fontSize: '1rem',
                  lineHeight: '1.5rem',
                  opacity: 0.8,
                  margin: '0',
                }}
              >
                We currently don't support this device, Click on the button below to send the login link to your Email and
                resume onboarding in Desktop.
              </p>
            </div>
            <div style={{ padding: '12px 30px 20px 30px', textAlign: 'center', display: 'flex', flexDirection: 'row' }}>
              <Button
                className="adPrimaryButtonOutlined"
                style={{ width: '70%', borderRadius: '8px', marginRight: '12px' }}
                onClick={sendLink}
              >
                I'll Explore here
              </Button>
              <Button
                disabled={sendEmail.loading}
                className="adPrimaryButton"
                style={{ width: '70%', borderRadius: '8px' }}
                onClick={sendLink}
              >
                <div style={{ display: 'inline-block', verticalAlign: 'initial', fontSize: '16px' }}>
                  {sendEmail.text}{' '}
                  {sendEmail.loading && <CircularProgress size={20} style={{ color: '#808080', marginLeft: '12px' }} />}
                </div>
              </Button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {sendEmail.text === 'Resend Link' && (
                <>
                  {!sendEmail.loading && sendEmail.emailSent ? (
                    <div style={{ color: 'green', textAlign: 'center' }}>
                      Email sent successfully to <span style={{ fontWeight: 500 }}>{user?.email}</span>
                    </div>
                  ) : (
                    <div style={{ color: 'red', textAlign: 'center' }}>
                      Something went wrong.
                      <br />
                      Please try after sometime.
                    </div>
                  )}
                </>
              )}
            </div>
            <div style={{ padding: '8px 30px 20px 30px', textAlign: 'center' }}>
              <img src={desktopView} style={{ width: '80%', maxWidth: '305px' }} />{' '}
            </div>
          </div>

          {/* </div> */}
        </Modal>
      </div>
    </>
  );
}

export default MainLayout;
